<section class="config-container shadow mt-4">
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{ active: subStep === SubStep.Finishes }"
    (click)="toggleCollapse()">
    {{ 'closet-doors.finishes.profile' | translate }}
  </h4>
  @if (subStep === SubStep.Finishes) {
    <div class="collapse-block">

      <!-- Niveau 1 : Matière (Acier / Aluminium) -->
      <ul class="frame-types">
        @for (frameType of frameTypes; track frameType.id) {
          <li
            class="frame-type-card"
            [ngClass]="{ active: selectedFrameType?.id === frameType.id }"
            (click)="selectFrameType(frameType)">
            <img [src]="baseImgURL + frameType.thumbnail" />
            <p>{{ frameType.name }}</p>
          </li>
        }
        @if (!frameTypes) {
          <ng-casto-loader></ng-casto-loader>
        }
      </ul>

      <!-- Niveau 2 : Profilés (C3, C4, ALU…) -->
      @if (frameProfiles?.length > 0) {
        <h5 class="finitions-count mt-3">
          {{ frameProfiles.length }} {{ 'closet-doors.finishes.profiles-count' | translate }}
        </h5>

        <ul class="frame-profiles">
          @for (frameProfile of frameProfiles; track frameProfile.id) {
            <li
              class="frame-profile-card"
              [ngClass]="{ active: selectedFrameProfile?.id === frameProfile.id }"
              (click)="selectFrameProfile(frameProfile)">
              @if (frameProfile.thumbnail) {
                <img [src]="baseImgURL + frameProfile.thumbnail" [alt]="frameProfile.nameFr" />
              }
              <p>{{ frameProfile.nameFr }}</p>
            </li>
          }
        </ul>
      }
      @if (!frameProfiles) {
        <ng-casto-loader></ng-casto-loader>
      }

      <!-- Niveau 3 : Finitions (couleurs) — visible uniquement si un profilé est sélectionné -->
      @if (selectedFrameProfile !== null) {
        <h5 class="finitions-count mt-3">
          {{ loadingProfiles ? skeletonItems.length : profiles.length }}
          {{ 'closet-doors.finishes.finitions-count' | translate }}
        </h5>

        <ul class="profiles">
          @if (loadingProfiles) {
            @for (_ of skeletonItems; track $index) {
              <li class="profile-card">
                <p-skeleton width="50px" height="50px" borderRadius="3px"></p-skeleton>
              </li>
            }
          } @else {
            @for (profile of profiles; track profile.id) {
              <li
                class="profile-card"
                [title]="profile.titleFr"
                [ngClass]="{ active: selectedProfile?.id === profile.id }"
                [ngStyle]="{ 'background-image': 'url(' + baseImgURL + profile.thumbnail + ')' }"
                (click)="selectProfile(profile)">
              </li>
            }
          }
        </ul>
      }

    </div>
  }
</section>
